// Tiny shared mutable singleton so R3F's useFrame can read document scroll
// without forcing a React re-render on every scroll tick.
export const scrollState = { offset: 0 }

if (typeof window !== 'undefined') {
  const update = () => {
    const max = document.documentElement.scrollHeight - window.innerHeight
    scrollState.offset = max > 0 ? Math.max(0, Math.min(1, window.scrollY / max)) : 0
  }
  window.addEventListener('scroll', update, { passive: true })
  window.addEventListener('resize', update, { passive: true })
  update()
}
